module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-view"
  }, [_vm._l((_vm.topList), function(item, index) {
    return _c('div', {
      key: index,
      class: item.tabViewActive,
      on: {
        "mouseover": function($event) {
          return _vm.mouseover(item)
        },
        "mouseleave": function($event) {
          return _vm.mouseleave(item)
        },
        "click": function($event) {
          return _vm.handleClick(item)
        }
      }
    }, [_c('div', {
      class: _vm.activeIndex === item.tabIndex ? 'text-view-active' : 'text-view'
    }, [_vm._v("\n      " + _vm._s(item.tabText) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "line-view"
    })])
  }), _vm._v(" "), (_vm.platformToken) ? _c('div', {
    staticClass: "user-meta-view"
  }, [_c('div', {
    staticClass: "meta-text"
  }, [_vm._v("\n      当前登录用户:" + _vm._s(_vm.platformUserData.userName) + "\n    ")])]) : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-376b686e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-376b686e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/main/TopView.vue
// module id = 1278
// module chunks = 1